import ImageWithFallback from "components/ImageWithFallback";
import Link from "next/link";
import cn from "clsx";
import {useEffect} from "react";

export default function CategoryCard(props) {
  const {
    data: category,
    baseUrl, cardType, categoryLevel, t,
    href=null
  } = props

  return (
    <Link key={category.slug}
               href={cardType === 'service' ? baseUrl : category.parent_category ? `${baseUrl}/${category.parent_category}` :  href||`${baseUrl}/${category.slug}`} >
      <a>
        <div className={'group cursor-pointer'}>
          <div className={categoryLevel=== 1 ? cn(["relative after:content-[''] after:block", 'after:pb-[75%] mb-2']) : "relative pb-[100%] h-0 mb-2 "}>
            <ImageWithFallback
              src={cardType === 'service' ? require(`assets/categories/services/${category.slug}.jpg`) :  require(`assets/categories/products/${category.slug}.jpg`)} alt={category.name}
              className="object-cover group-hover:brightness-105"
            />
          </div>
          <div className="font-semibold text-center">
            {!!t ? t(`home:${category.slug}`) : ''}
          </div>
        </div>
      </a>
    </Link>
  )
}
